import { render, staticRenderFns } from "./BaseFrontOfficeParagraph.vue?vue&type=template&id=6bfea670&scoped=true"
import script from "./BaseFrontOfficeParagraph.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeParagraph.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeParagraph.vue?vue&type=style&index=0&id=6bfea670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfea670",
  null
  
)

export default component.exports